<!-- STRAT NAVBAR -->
<nav class="navbar navbar-expand-lg fixed-top navbar-custom sticky sticky-dark" (window:scroll)="windowScroll()"
  id="navbar">
  <div class="container">
    <!-- LOGO -->
    <div class="logo-white"></div>
    <a class="navbar-brand logo text-uppercase" href="/">
      Algebraic Technologies LTD
    </a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarCollapse"
      (click)="toggleMenu()" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
      <i class="mdi mdi-menu"></i>
    </button>
    <div class="collapse navbar-collapse" id="navbarCollapse">
      <ul class="navbar-nav navbar-center" id="mySidenav">
        <li class="nav-item" [ngClass]="{'active':currentSection === 'home'}">
          <a [ngxScrollTo]="'#home'" href="javascript: void(0);" class="nav-link">Home</a>
        </li>
        <li class="nav-item" [ngClass]="{'active':currentSection === 'services'}">
          <a (click)="scrollToElement('services')" href="javascript: void(0);" class="nav-link">Services</a>
        </li>
        <li class="nav-item" [ngClass]="{'active':currentSection === 'features'}">
          <a (click)="scrollToElement('aboutUs')" href="javascript: void(0);" class="nav-link">Features</a>
        </li>
        <li class="nav-item" [ngClass]="{'active':currentSection === 'team'}">
          <a (click)="scrollToElement('team')" href="javascript: void(0);" class="nav-link">Team</a>
        </li>
        <li class="nav-item" [ngClass]="{'active':currentSection === 'awards'}">
          <a (click)="scrollToElement('awards')" href="javascript: void(0);" class="nav-link">Awards</a>
        </li>
        <li class="nav-item" [ngClass]="{'active':currentSection === 'contact'}">
          <a [ngxScrollTo]="'#contact'" href="javascript: void(0);" class="nav-link">Contact</a>
        </li>
      </ul>
      <!-- <div class="nav-button ms-auto">
         <ul class="nav navbar-nav navbar-end">
           <li>
             <button type="button" class="btn btn-primary navbar-btn btn-rounded">Try it
               Free</button>
           </li>
         </ul>
       </div>-->
    </div>
  </div>
</nav>
<!-- END NAVBAR -->
<!--START HOME-->
<section class="section section-lg vh-100 active" id="home"
  style="background-image: url('assets/images/home.jpg'); background-size: cover; background-position: center;">
  <div class="bg-overlay"></div>
  <div class="display-table">
    <div class="display-table-cell">
      <div class="container">
        <div class="row">
          <div class="col-lg-8 offset-lg-2 text-white text-center margin_off">
            <h1 id="slideTitile" clas="home-title text-rotate">CRYPTOCURRENCY PROJECT SUPPORT SYSTEM</h1>
            <p class="pt-3 home-desc" id="slideBody">Formal Verification and Analysis Service for the Blockchain
              Solutions from a team with over 20 years experience in industrial formal verification, algebraic
              modelling, cybersecurity, model-based testing and blockchain projects development.

            </p>
            <div class="buttonsForSlide">
              <a href="https://tokenomics.expert/" class="btn btn-primary waves-light waves-effect mt-5" target="_blank">BUILD YOUR SUSTAINABLE
                TOKENOMICS NOW!</a>

              <a href="javascript: void(0);" (click)="scrollToElement('workProc')"  class="btn btn-primary waves-light waves-effect mt-5">How it's work?</a>
            </div>
            <!--<p class="play-shadow margin-t-30 margin-l-r-auto"><a (click)="openModal(content)"
                 class="play-btn video-play-icon"><i class="mdi mdi-play text-center"></i></a></p>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--END HOME-->

<ng-template #content let-modal>
  <div class="modal-content home-modal">
    <div class="modal-header border-0">
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
        (click)="modal.dismiss('Cross click')"></button>
    </div>
    <video id="VisaChipCardVideo" class="video-box" controls>
      <source src="https://www.w3schools.com/html/mov_bbb.mp4" type="video/mp4">
    </video>
  </div>
</ng-template>

<div appScrollspy [spiedTags]="['SECTION']" (sectionChange)="onSectionChange($event)">
  <app-services></app-services>
  <app-features></app-features>
  <app-pricing></app-pricing>
  <app-team></app-team>
  <app-blog></app-blog>
  <app-contact></app-contact>
  <app-footer></app-footer>
</div>